"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var isPaidStory = function (story) {
    return !!(story === null || story === void 0 ? void 0 : story.isPaywalled);
};
exports.default = isPaidStory;
